import {OrganizationUserLicensePermissionModel} from '../../model/organization/organization-user-license-permission.model';
import {OrganizationUserPermissionModel} from '../../model/organization/organization-user-permission.model';
import {OrganizationUserModel} from '../../model/organization/organization-user.model';
import {UserPermissionEnum} from '../../model/organization/user-permission.enum';
import axios from '../axios';

export namespace OrganizationUserController {
  export const queryOrganizationUsers = async (organizationId: string) =>
    (await axios.get<OrganizationUserModel[]>(`/internal/users?organizationId=${organizationId}`)).data

  export const queryOrganizationUserLicensePermissions = async (userId: string) =>
    (await axios.get<OrganizationUserLicensePermissionModel[]>(`/internal/users/${userId}/license/permissions`)).data

  export const updateOrganizationUserPermission = async (groupId: string, userId: string, featureLicenseId: string, action: 'CREATE' | 'DELETE') =>
    (await axios.put(`/internal/license/group/${groupId}/users/${userId}/permissions`, {
      featureLicenseId: featureLicenseId,
      action: action
    }))

  export const queryOrganizationUserPermissions = async (userId: string) =>
    (await axios.get<OrganizationUserPermissionModel[]>(`/internal/users/${userId}/permissions`)).data

  export const createOrganizationUserPermissions = async (userId: string, permission: UserPermissionEnum) =>
    (await axios.post(`/internal/users/${userId}/permissions`, {permission: permission})).data

  export const deleteOrganizationUserPermissions = async (userId: string, permissionId: string) =>
    (await axios.put(`/internal/users/${userId}/permissions`, {permissionId: permissionId})).data
}